import styled from 'styled-components';
import { IconActionLink } from '@cko/icons';
export const StyledActionLink = styled(IconActionLink) `
  ${({ margin }) => margin && `margin: ${margin};`}

  cursor: pointer;

  path {
    fill: var(--action-icon-primary);
`;
